/* eslint-disable consistent-return */

import { Meteor } from 'meteor/meteor';
import { Roles } from 'meteor/alanning:roles';
import path from 'path';
import Missions from '../../Missions/Missions';
import Projects from '../../Projects/Projects';
import RPAs from '../../RPAs/RPAs';
import Payloads from '../../Payloads/Payloads';
import Batteries from '../../Batteries/Batteries';
import Maps from '../../Maps/Maps';
import Layers from '../../Layers/Layers';
import Videos from '../../Videos/Videos';
import Annotations from '../../Annotations/Annotations';
import { deleteFolderRecursiveSync } from '../../../modules/server/file-system';

let action;

const deleteUser = userId => {
  try {
    return Meteor.users.remove(userId);
  } catch (exception) {
    throw new Error(`[deleteAccount.deleteUser] ${exception.message}`);
  }
};

const deleteMissions = userId => {
  try {
    return Missions.remove({ owner: userId });
  } catch (exception) {
    throw new Error(`[deleteAccount.deleteMissions] ${exception.message}`);
  }
};

const deleteRPAs = userId => {
  try {
    return RPAs.remove({ owner: userId });
  } catch (exception) {
    throw new Error(`[deleteAccount.deleteRPAs] ${exception.message}`);
  }
};

const deletePayloads = userId => {
  try {
    return Payloads.remove({ owner: userId });
  } catch (exception) {
    throw new Error(`[deleteAccount.deletePayloads] ${exception.message}`);
  }
};

const deleteBatteries = userId => {
  try {
    return Batteries.remove({ owner: userId });
  } catch (exception) {
    throw new Error(`[deleteAccount.deleteBatteries] ${exception.message}`);
  }
};

const deleteProjects = userId => {
  try {
    return Projects.remove({ owner: userId });
  } catch (exception) {
    throw new Error(`[deleteAccount.deleteProjects] ${exception.message}`);
  }
};

const deleteMaps = userId => {
  try {
    return Maps.remove({ owner: userId });
  } catch (exception) {
    throw new Error(`[deleteAccount.deleteMaps] ${exception.message}`);
  }
};

const deleteLayers = userId => {
  try {
    return Layers.remove({ owner: userId });
  } catch (exception) {
    throw new Error(`[deleteAccount.deleteLayers] ${exception.message}`);
  }
};

const deleteVideos = userId => {
  try {
    return Videos.remove({ owner: userId });
  } catch (exception) {
    throw new Error(`[deleteAccount.deleteVideos] ${exception.message}`);
  }
};

const deleteAnnotations = userId => {
  try {
    return Annotations.remove({ owner: userId });
  } catch (exception) {
    throw new Error(`[deleteAccount.deleteAnnotations] ${exception.message}`);
  }
};

const deleteUserFiles = userId => {
  try {
    const userDir = path.join(Meteor.settings.private.config.dataPath, 'users', userId);
    return deleteFolderRecursiveSync(userDir);
  } catch (error) {
    if (error.code === 'EACCES') {
      console.error('Error deleting user folder, probably due to permission eror');
      throw error;
    } else if (error.code === 'ENOENT') {
      console.info('Error deleting user folder, probably due to non exitent folder');
      return { deletedFiles: 0, deletedFolders: 0 };
    } else {
      console.error(error);
      throw error;
    }
  }
};

const deleteAccount = ({ userId }, promise) => {
  try {
    if (Roles.userIsInRole(Meteor.userId(), ['admin']) || userId === Meteor.userId()) {
      action = promise;
      const filesDeleted = deleteUserFiles(userId);
      deletePayloads(userId);
      deleteRPAs(userId);
      deleteBatteries(userId);
      deleteMissions(userId);
      deleteLayers(userId);
      deleteMaps(userId);
      deleteAnnotations(userId);
      deleteVideos(userId);
      deleteProjects(userId);
      deleteUser(userId);
      action.resolve(filesDeleted);
    } else {
      throw new Error('Ha! Nice try, slick.');
    }
  } catch (exception) {
    action.reject(exception.message);
  }
};

export default options =>
  new Promise((resolve, reject) => deleteAccount(options, { resolve, reject }));
